// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
    return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/interopDefault.js
// module id = 224
// module chunks = 0